import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="widget-filters-list"
export default class extends Controller {
  static targets = [ "filtersList", "addFilterButton", "addFilterButtonText", "filterWrapper", "filterLabelContainer" ]
  static values = { addFilterUrl: String }

  connect() {
    this.updateTargets()

    const container = this.filtersListTarget

    if (!this.observer) {
      this.observer = new MutationObserver(mutations => {
        mutations.forEach(() => this.updateTargets())
      })
    }

    this.observer.observe(container, { childList: true })
  }

  disconnect() {
    this.observer = null
  }

  addFilter(event) {
    event.preventDefault()

    const index = this.filterWrapperTargets.length
    const url = this.addFilterUrlValue

    fetch(`${url}?index=${index}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }

  removeFilter(event) {
    event.preventDefault()
    event.target.closest(".filter-wrapper").remove()
  }

  updateTargets() {
    this.updateAddFilterButton()
    this.updateFilterLabels()
    this.updateFixedTypeAvailability()
  }

  filterChanged() {
    this.updateFixedTypeAvailability()
  }

  updateFixedTypeAvailability() {
    const selectedFixedTypes = this.collectSelectedFixedTypesByWrapper()

    this.filterWrapperTargets.forEach((wrapper, wrapperIndex) => {
      this.applyFixedTypeAvailability(wrapper, wrapperIndex, selectedFixedTypes)
    })
  }

  collectSelectedFixedTypesByWrapper() {
    return this.filterWrapperTargets.map(wrapper => this.selectedFixedTypeFor(wrapper))
  }

  selectedFixedTypeFor(wrapper) {
    if (!this.isFixedFilter(wrapper))
      return null

    return this.checkedFixedTypeInput(wrapper)?.value ?? null
  }

  applyFixedTypeAvailability(wrapper, wrapperIndex, selectedFixedTypes) {
    const isFixedFilter = this.isFixedFilter(wrapper)

    wrapper.querySelectorAll('input[name$="[fixed_type]"]').forEach(radio => {
      const takenByAnotherFilter = this.isFixedTypeTakenByAnotherFilter(radio.value, wrapperIndex, selectedFixedTypes)
      radio.disabled = isFixedFilter && takenByAnotherFilter && !radio.checked
    })
  }

  isFixedTypeTakenByAnotherFilter(fixedType, wrapperIndex, selectedFixedTypes) {
    return selectedFixedTypes.some((selectedFixedType, index) =>
      index !== wrapperIndex && selectedFixedType === fixedType
    )
  }

  isFixedFilter(wrapper) {
    const FIXED_FILTER_TYPE = "fixed"
    return this.checkedTypeInput(wrapper)?.value === FIXED_FILTER_TYPE
  }

  checkedTypeInput(wrapper) {
    return wrapper.querySelector('input[name$="[type]"]:checked')
  }

  checkedFixedTypeInput(wrapper) {
    return wrapper.querySelector('input[name$="[fixed_type]"]:checked')
  }

  updateAddFilterButton() {
    const maxFilters = 3
    const currentFilters = this.filterWrapperTargets.length
    this.updateAddFilterButtonText()

    this.addFilterButtonTarget.classList.toggle("hidden!", currentFilters >= maxFilters)
    this.addFilterButtonTarget.classList.toggle("mt-30", currentFilters >= 1)
  }

  updateFilterLabels() {
    this.filterLabelContainerTargets.forEach((label, index) => {
      label.textContent = `Filter ${index + 1}`
    })
  }

  updateAddFilterButtonText() {
    this.addFilterButtonTextTarget.textContent = !this.filterWrapperTargets.length
      ? "Add filter"
      : "Add another filter"
  }
}
